import { render, staticRenderFns } from "./Related.vue?vue&type=template&id=b37d86a2&scoped=true"
import script from "./Related.vue?vue&type=script&lang=js"
export * from "./Related.vue?vue&type=script&lang=js"
import style0 from "../assets/main.css?vue&type=style&index=0&id=b37d86a2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37d86a2",
  null
  
)

export default component.exports